var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0.426758H10C4.47715 0.426758 0 4.79473 0 10.1829V24.8171C0 30.2053 4.47715 34.5733 10 34.5733H25C30.5228 34.5733 35 30.2053 35 24.8171V10.1829C35 4.79473 30.5228 0.426758 25 0.426758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.939C19.3135 26.9407 20.6143 26.6891 21.8278 26.1987C23.0413 25.7083 24.1435 24.9888 25.071 24.0815C26.001 23.1765 26.7385 22.1012 27.2411 20.9174C27.7438 19.7335 28.0017 18.4643 28 17.1829C28.0017 15.9015 27.7438 14.6323 27.2411 13.4485C26.7385 12.2646 26.001 11.1893 25.071 10.2843C24.1435 9.37703 23.0413 8.6575 21.8278 8.1671C20.6143 7.6767 19.3135 7.42511 18 7.42677C16.6865 7.42513 15.3857 7.67674 14.1722 8.16714C12.9587 8.65754 11.8566 9.37705 10.929 10.2843C9.99904 11.1893 9.26154 12.2646 8.75889 13.4485C8.25623 14.6323 7.99833 15.9015 8.00001 17.1829C7.99831 18.4643 8.25619 19.7335 8.75885 20.9174C9.26151 22.1012 9.99902 23.1765 10.929 24.0815C11.8566 24.9888 12.9587 25.7083 14.1722 26.1987C15.3857 26.6891 16.6865 26.9407 18 26.939V26.939Z",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22.061C18.2652 22.061 18.5196 21.9582 18.7071 21.7753C18.8946 21.5923 19 21.3442 19 21.0854C19 20.8267 18.8946 20.5785 18.7071 20.3956C18.5196 20.2126 18.2652 20.1098 18 20.1098C17.7348 20.1098 17.4804 20.2126 17.2929 20.3956C17.1054 20.5785 17 20.8267 17 21.0854C17 21.3442 17.1054 21.5923 17.2929 21.7753C17.4804 21.9582 17.7348 22.061 18 22.061Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.3048V18.5487",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVersion);
export default __webpack_public_path__ + "static/media/icon-version.0333c0842e71b7016c6d74bac329594d.svg";
export { ForwardRef as ReactComponent };